<tui-input
  formControlName="description"
  [tuiTextfieldSize]="tuiElementLargeSize"
  [class.tui-skeleton]="loading"
  [class.tui-skeleton_text]="loading"
>
  <!-- Изменить -->
  {{ 'components.contacts.fields.contactName' | translate }}
</tui-input>
